"use strict";

$(document).ready(function () {
    console.log("Client loyalty begin");

    addClubLoyaltyImage();

    $(".close").on("click", (e) => {
        $(e.currentTarget).closest("#loyaltyAssignClub").addClass("fade").removeClass("d-flex");
    });


    $(".btn-loyalty-red").on("click", (e) => {
        loyaltyModel(e.currentTarget.dataset.loyalty);
    });
    $(".btn-loyalty-transparent").on("click", (e) => {
        loyaltyModel(e.currentTarget.dataset.loyalty);
    });
    $(".btn-loyalty-green").on("click", (e) => {
        redirectToLoyaltyClubPage(e.currentTarget.dataset.loyalty);
    });

    var erroLoyaltyService = $("#error-loyalty");
    var isRegister = $("#isRegister");

    if (erroLoyaltyService && erroLoyaltyService.val() != "") {
        console.log("getCustomerClubSubscriptions service error:" + erroLoyaltyService.val());
    }

});

function addClubLoyaltyImage() {

}
/**
 * Generates and start the modal structure
 *
 */
async function loyaltyModel(loyaltyClubNo, rut, redirect) {
    if (loyaltyClubNo && loyaltyClubNo != "undefined") {
        console.log("Client Loyalty model begin");
        var formulario = await checkForQuestionsBasedOnClubNo(loyaltyClubNo, rut, redirect);
        console.log("Client Loyalty model retorno gerouModal ");
        console.log("aqui");
        console.log(formulario.gerouModal);
        if (formulario.respostaVazia) {
            loyaltyModel(loyaltyClubNo, rut, redirect);
        } else if (formulario.gerouModal) {
            console.log("Client Loyalty model retorno gerouModal true");
            console.log("Client loyalty has Modal", $("#loyaltyAssignClub"));            
            //$("#loyaltyAssignClub").removeClass("fade").addClass("d-flex");
        } else {
            if (redirect && redirect != "") {
                console.log("Client loyalty end with redirect");
                location.href = redirect;
            } else { 
                console.log("Client loyalty end with no redirect");                
            }
        }
    }
}

/**
 * Generates the lsit of clubs to be in "mi cuenta"
 *
 */
async function checkAndGenerateListOfClubs() {
    // await $.ajax({
    //     url: "/on/demandware.store/Sites-ahumada-cl-Site/es_CL/Loyalty-Subscriptions",
    //     type: "GET",
    //     dataType: "json",
    //     success: function (data) {
    //         if (data.loyaltyClubs) {
    //             //loyaltyDiv = "";
    //             data.loyaltyClubs.forEach(function (loyaltyClub) {
    //                 var loyaltyHtml = "<div class='col-12 float-left mb-2'>";
    //                 loyaltyHtml += "<div class='col-6 float-left mt-2'>";
    //                 loyaltyHtml += `<p class=""> ${loyaltyClub.name} </p>`;
    //                 loyaltyHtml += "</div><div class='col-6 float-left'>";
    //                 loyaltyHtml += `<button style="width: 160px;" class="btn btn-loyalty ${loyaltyClub.isMember ? loyaltyClub.isActived ? 'btn-loyalty-green' : 'btn-loyalty-transparent': 'btn-loyalty-red'}" data-loyalty="${loyaltyClub.code}">${loyaltyClub.isMember ? loyaltyClub.isActived ? 'Registrado' : 'Renovar' : 'Participar' }</button>`;
    //                 loyaltyHtml += "</div>";
    //                 loyaltyHtml += "</div>";
    //                 loyaltyDiv += loyaltyHtml;
    //             });
    //             loyaltyDiv += "</div>";
    //             $(".loyaltyDiv").html(loyaltyDiv);
    //         }
    //     },
    //     error: function (e) {
    //         $(".loyaltyDiv").html = e.message;
    //     }
    // });
    // console.log("pegou referencia botao .btn-loyalty-red ?", $(".btn-loyalty-red"));
    // console.log("pegou referencia botao .btn-loyalty-transparent?", $(".btn-loyalty-transparent"));
    // console.log("pegou referencia botao .btn-loyalty-green ?", $(".btn-loyalty-green"));
    // $(".btn-loyalty-red").on("click", (e) => {
    //     loyaltyModel(e.currentTarget.dataset.loyalty);
    // });
    // $(".btn-loyalty-transparent").on("click", (e) => {
    //     loyaltyModel(e.currentTarget.dataset.loyalty);
    // });
    // $(".btn-loyalty-green").on("click", (e) => {
    //     redirectToLoyaltyClubPage(e.currentTarget.dataset.loyalty);
    // });
}

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    // var htmlString =
    //     `"<!-- Modal -->"
    //     <div class="modal fade" id="loyaltyAssignClub" tabindex="-1" role="dialog">
    //         <span class="enter-message sr-only" ></span>
    //         <div class="modal-dialog quick-view-dialog">
    //             <form>
    //                 <!-- Modal content-->
    //                 <div class="modal-content p-2">
    //                     <span class="close cancel-club-bb">×</span>
    //                     <h2 class="title-club-bb">Inscripción al Programa Beneficios <strong>Club Mi Bebé</strong></h2>
    //                     <div class="modal-body" style=" width:500poux">
    //                     </div>
    //                     <div class="modal-footer d-flex justify-content-between">
    //                     </div>
    //                 </div>
    //             </form>
    //         </div>
    //     </div>`;
    // $("body").append(htmlString);    
    var htmlString =
        `<div class="card-body p-0 card-profile">
            <div class="" id="loyaltyAssignClub" tabindex="-1" role="dialog">
             <span class="enter-message sr-only" ></span>
             <div class="">
                 <form>
                     <!-- Modal content-->
                     <div class="modal-content p-2">
                         <span class="close cancel-club-bb d-none">×</span>
                         <h2 class="title-club-bb">Inscripción al Programa Beneficios <strong>Club Mi Bebé</strong></h2>
                         <div class="modal-body" style=" width:500poux">
                         </div>
                         <div class="modal-footer d-flex justify-content-between">
                         </div>
                     </div>
                 </form>
             </div>        
    </div>`;        
    $(".loyaltyDiv").html(htmlString);

    $(".close").on("click", (e) => {
        console.log("fechar?");
        //$(e.currentTarget).closest("#loyaltyAssignClub").addClass("fade").removeClass("d-flex");
    });
}

function redirectToLoyaltyClubPage(clubId) {
    if (clubId && clubId != "") {
        window.location.href = "https://www.farmaciasahumada.cl/club-bebe.html";
    }
}

function renewLoyaltyClube(loyaltyClubNo) {
    console.log("renew loyalty");
    getModalHtmlElement();
    checkForQuestionsBasedOnClubNo(loyaltyClubNo);

}

/**
 * Generates the Loyalty Questions to HTML
 *
 */
function generateLoyaltyQuestionsHTML(loyaltyQuestions) {
    console.log("generate loyalty question html");
    getModalHtmlElement();
    // Start with an empty string to hold our HTML
    let formHTML = "";

    // Loop through each top-level question and generate HTML
    var gerouPerguntas = true;
    for (let index = 0; index < loyaltyQuestions.length; index++) {
        const question = loyaltyQuestions[index];

        // formHTML += `<div class="row">`;
        formHTML += "   <div class=\"form-group\">";
        var perguntaHtml = createQuestionHTML(question);
        gerouPerguntas = gerouPerguntas && perguntaHtml && perguntaHtml != "";
        formHTML += perguntaHtml;
        formHTML += "   </div>";
    }

    // Function to recursively create HTML for questions
    function createQuestionHTML(question) {
        let html = "";
        if (question.type === "Text") {
            // html += `<label class="form-control-label">${question.question}</label>`;
            html += `
            ${question.question ? "<label>"+question.question+"</label>" : ""}
            <input type="number" min="0" step="1" placeholder="${question.question}" class="form-control form-rut-field questionario${question.id} input-club-bb">`;
        } else if (question.type && question.type.includes("ListM")) {
            html += `<div class="checkbox-container d-flex flex-column mt-2 questionario${question.id}">
                ${question.question ? "<label>"+question.question+"</label>" : ""}
                ${question.options.map(option => `<label><input type="checkbox" class="questionario${question.id}" value="${option.value}">${option.label}</label>`).join("")}
            </div>`;
        } else if (question.type && question.type.includes("List")) {
            html += `<div class="radio-group">
            ${question.question ? "<label>"+question.question+"</label>" : ""}
                <div class="radio-options">
                    ${ question.options.map(option => `<label class="radio-option">
                    <input type="radio" name="questionario${question.id}" class="questionario${question.id}" value="${option.value}"> ${option.label}
                    </label>`).join("")}
                </div>
            </div>`;
        } else if (question.type && question.type.includes("Number")) {
            html += `<div class="form-group mb-3 questionario${question.id}">
                    ${question.question ? "<label>"+question.question+"</label>" : ""}
                    <input class="club-bebe-form" type="number" placeholder="0">
                </div>`;
        } 

        return html;
    }

    // Return the generated HTML
    return {html : formHTML, gerouPerguntas : gerouPerguntas};
}

/**
 * Check for the questions related to club number
 *
 */
async function checkForQuestionsBasedOnClubNo(loyaltyClubNo, rut, redirect) {
    var modalHtml = "";
    var respostaVazia = false;    
    if (loyaltyClubNo && loyaltyClubNo != "undefined") {
        console.log("Client loyalty Check questions " + loyaltyClubNo);
        await $.ajax({
            url: "/on/demandware.store/Sites-ahumada-cl-Site/es_CL/Loyalty-Inscription?clubID=" + loyaltyClubNo + "&rut=" + rut,
            method: "GET",
            dataType: "json",
            success: function (data) {

                console.log("Client loyalty Check questions success");

                if (data.success && data.inscriptionFormObject) {
                    console.log("Client loyalty Check form Object exists");
                    var questionsList = data.inscriptionFormObject ? JSON.parse(data.inscriptionFormObject) : "";
                    var objectHtml = generateLoyaltyQuestionsHTML(questionsList);

                    if (objectHtml.gerouPerguntas) {
                        console.log("Client loyalty Check form gerouPerguntas true");
                        modalHtml = objectHtml.html;

                        // let inputsqwe = `
                        //     <div class="rut-container">
                        //         <input class="club-bebe-form" type="text" name="rut_numero" placeholder="`+data.cliente.rut+`" maxlength="8" disabled>
                        //         <span class="rut-separator">-</span>
                        //         <input class="club-bebe-form" type="text" name="rut_dv" placeholder="`+data.cliente.dv+`" maxlength="1" disabled>
                        //     </div>
                        //     <div class="form-group">
                        //         <input class="club-bebe-form" type="text" name="nombre" placeholder="`+data.cliente.nombre+`" disabled>
                        //     </div>
                        //     <div class="form-group">
                        //         <input class="club-bebe-form" type="text" name="apellido" placeholder="`+data.cliente.apellido+`" disabled>
                        //     </div>
                            
                        //     <div class="form-group">
                        //         <input class="club-bebe-form" type="tel" name="telefono" placeholder="`+data.cliente.telefono+`" disabled>
                        //     </div>
                            
                        //     <div class="form-group" style="height: 70px; display: flex; flex-direction: column">
                        //         <input class="club-bebe-form" type="email" name="email" placeholder="`+data.cliente.email+`" disabled>
                        //     </div>                            

                        // ` + modalHtml;

                        $("#loyaltyAssignClub .modal-body").html(modalHtml);

                        $("#loyaltyAssignClub .modal-footer").html(`

                                <button href="#" id="btn-loyalty-save" class="btn px-0 btn-save btn-block btn-primary font-medium save-club-bb " disabled data-loyalty-club-no="${loyaltyClubNo}" data-questions='${data.inscriptionFormObject}' data-code="${data.code}" >
                                Enviar Inscripción
                                </button>
                            </div>
                        `);

                        $(".close").on("click", (e) => {
                            $(e.currentTarget).closest("#loyaltyAssignClub").addClass("fade").removeClass("d-flex");
                            console.log("Client Loyalty Questions User Cancel");
                            if (redirect && redirect != "") {
                                console.log("Client Loyalty Questions User Cancel with redirect");
                                location.href = redirect;
                            }

                        });

                        // var questionsEventos = $("#btn-loyalty-save").data("questions")

                        // for (let index = 0; index < questionsEventos.length; index++) {
                        //     var questionEvento = questionsEventos[index];
                        //     console.log('respostas ;-)')

                        //     $('.questionario' + questionEvento.id).on('change', function() {
                        //         console.log('Valor input mudou para:', $(this).val());
                        //     });

                        //     $('.questionario' + questionEvento.id).on('input', function() {
                        //         console.log('Valor select mudou para:', $(this).val());
                        //     });                            

                        // }

                        // $('#loyaltyAssignClub .modal-body').on('change', 'input[type="checkbox"]:checked, input[type="text"]', function () {
                        //     // const valor = $(this).val();
                        //     // const tipo = $(this).attr('type');
                        //     // const marcado = $(this).is(':checked');
                            
                        //     // console.log(`Tipo: ${tipo} | Valor: ${valor} | Checked: ${marcado}`);

                        //     var questionsEventos = $("#btn-loyalty-save").data("questions")

                        //     var desabilitaBotao = true
                        //     for (let index = 0; index < questionsEventos.length; index++) {
                        //         var questionEvento = questionsEventos[index];
                        //         console.log('valor resposta');
                        //         console.log($(".questionario" + questionEvento.id).val());

                        //         if ($(".questionario" + questionEvento.id).is(':checked')) {
                        //             console.log('Resposta radio: '+$(".questionario" + questionEvento.id).val());
                        //         }
                                
                        //         desabilitaBotao = $(".questionario" + questionEvento.id).val() == undefined;
                        //         console.log(desabilitaBotao)
                        //     }
                            
                        //     $('#btn-loyalty-save').prop('disabled', desabilitaBotao);

                        // });                        

                        $("#loyaltyAssignClub .modal-body").on("change input", "input[type=\"checkbox\"], input[type=\"radio\"], input[type=\"number\"], input[type=\"text\"]", function () {
                            const questionsEventos = $("#btn-loyalty-save").data("questions");
                            let desabilitaBotao = false;

                            for (let index = 0; index < questionsEventos.length; index++) {
                                const questionEvento = questionsEventos[index];
                                const $elementos = $("input.questionario" + questionEvento.id); // só inputs

                                if ($elementos.length === 0) continue;

                                const tipo = $elementos.first().attr("type");
                                console.log(`Pergunta ${questionEvento.id} tipo detectado:`, tipo);

                                if (questionEvento && (questionEvento.id == "Q01" || questionEvento.id == "Q02")) {
                                    if (tipo === "checkbox") {
                                        const selecionados = $elementos.filter(":checked").map(function () {
                                            return $(this).val();
                                        }).get();

                                        console.log(`Pergunta ${questionEvento.id} (checkbox) selecionados:`, selecionados);

                                        if (selecionados.length === 0) {
                                            desabilitaBotao = true;
                                            break;
                                        }
                                    } else if (tipo === "radio") {
                                        const selecionados = $elementos.filter(":checked").map(function () {
                                            return $(this).val();
                                        }).get();

                                        console.log(`Pergunta ${questionEvento.id} (radio) selecionados:`, selecionados);

                                        if (selecionados.length === 0) {
                                            desabilitaBotao = true;
                                            break;
                                        } else {
                                            $(".questionarioQ02").prop("disabled", selecionados[0] == "2");
                                        }
                                        
                                    } else if (tipo === "text") {
                                        const valor = $elementos.val()?.trim();
                                        console.log(`Pergunta ${questionEvento.id} (texto) digitado:`, valor);

                                        if (!valor) {
                                            desabilitaBotao = true;
                                            break;
                                        }
                                    } else if (tipo === "number") {
                                        const valor = $elementos.val()?.trim();
                                        console.log(`Pergunta ${questionEvento.id} (texto) digitado:`, valor);

                                        if ((questionEvento.id == "Q04" && !valor) || (questionEvento.id == "Q02" && !$elementos.prop("disabled") && !valor)) {
                                            desabilitaBotao = true;
                                            break;
                                        }
                                    }

                                }


                            }

                            $("#btn-loyalty-save").prop("disabled", desabilitaBotao);
                        });

                        $("#btn-loyalty-save").on("click", (e) => {

                            console.log("Client Loyalty Questions User Save");
                            console.log($("#btn-loyalty-save").data("loyalty-club-no"));

                            var questions = $("#btn-loyalty-save").data("questions");
                            console.log(questions);

                            var quantidadeRespostas = 0;
                            var respostas = "";
                            for (let index = 0; index < questions.length; index++) {
                                var question = questions[index];
                                console.log("respostas ;-)");

                                const $elementos = $("input.questionario" + question.id);
                                const tipo = $elementos.first().attr("type");
                                console.log(`Resposta ${question.id} tipo detectado:`, tipo);

                                if (tipo === "checkbox") {
                                    const selecionados = $elementos.filter(":checked").map(function () {
                                        return $(this).val();
                                    }).get();

                                    console.log(`Resposta ${question.id} (checkbox) selecionados:`, selecionados);

                                    quantidadeRespostas = quantidadeRespostas + 1;
                                    respostas = respostas + question.id + "|" + selecionados.toString().replace(",", ";") + "|";

                                } else if (tipo === "radio") {
                                    const selecionados = $elementos.filter(":checked").map(function () {
                                        return $(this).val();
                                    }).get();

                                    console.log(`Resposta ${question.id} (radio) selecionados:`, selecionados);

                                    quantidadeRespostas = quantidadeRespostas + 1;
                                    respostas = respostas + question.id + "|" + selecionados + "|";

                                } else if (tipo === "number") {
                                    const valor = $elementos.val()?.trim();
                                    console.log(`Pergunta ${question.id} (texto) digitado:`, valor);

                                    quantidadeRespostas = quantidadeRespostas + 1;
                                    respostas = respostas + question.id + "|" + valor + "|";

                                } else if (tipo === "text") {
                                    const valor = $elementos.val()?.trim();
                                    console.log(`Pergunta ${question.id} (texto) digitado:`, valor);

                                    quantidadeRespostas = quantidadeRespostas + 1;
                                    respostas = respostas + question.id + "|" + valor + "|";

                                }


                                console.log("|CB|" + quantidadeRespostas + "|" + respostas);

                                // if ($(".questionario" + question.id).val()) {
                                //     console.log('resposta:'+index)
                                //     console.log(question.id)
                                //     console.log($(".questionario" + question.id).val())
                                //     quantidadeRespostas = quantidadeRespostas + 1;
                                //     respostas = respostas + question.id + '|' + $(".questionario" + question.id).val() + '|'
                                //     console.log($(".questionario" + question.id))
                                //     console.log($(".questionario" + question.id).val())
                                // } else {
                                //     respostaVazia = true;
                                // }
                            }

                            // revisar
                            respostaVazia = false;

                            var form = {
                                loyaltyClubNo: $("#btn-loyalty-save").data("loyalty-club-no"),
                                code: $("#btn-loyalty-save").data("code"),
                                respostasString: "|CB|" + quantidadeRespostas + "|" + respostas
                            };

                            console.log("save inscricao");

                            $.ajax({
                                url: "/on/demandware.store/Sites-ahumada-cl-Site/es_CL/Loyalty-Subscribe",
                                method: "POST",
                                dataType: "json",
                                data: form,
                                success: function (data) {
                                    console.log("Client Loyalty Questions User Save Success");

                                    if (data.success) {
                                        if (redirect && redirect != "") {
                                            console.log("Loyalty client end with redirect");
                                            location.href = redirect;
                                        } else {
                                            location.reload();
                                        }
                                    } else {
                                        console.log("Client Loyalty Questions User Save Error: " + err.errorMessage);                                          
                                    }

                                    // var formHTML = `
                                    // <div class="row">
                                    //     <div class="form-group col-12">
                                    //         ¡Registro exitoso!
                                    //     </div>
                                    // </div>`;
                                    // $("#loyaltyAssignClub .modal-body").html(formHTML);

                                    //$.spinner().stop();
                                },
                                error: function (err) {
                                    console.log("Client Loyalty Questions User Save Error: " + err.errorMessage);  
                                    
                                    if (redirect && redirect != "") {
                                        console.log("Loyalty client end with error and redirect");
                                        location.href = redirect;
                                    }
                                    //     location.reload();
                                    // }
                                    
                                    // var formHTML = `
                                    // <div class="row">
                                    //     <div class="form-group col-12">
                                    //         Error al registrarse. Inténtalo de nuevo más tarde.
                                    //     </div>
                                    // </div>`;
                                    // $("#loyaltyAssignClub .modal-body").html(formHTML);

                                    //$.spinner().stop();
                                }
                            });

                            // } else {
                            //     var formHTML = `
                            //     <div class="row">
                            //         <div class="form-group col-12">
                            //             Todos los campos son obligatorios, por favor inténtalo de nuevo.
                            //         </div>
                            //     </div>`;
                            //     $("#loyaltyAssignClub .modal-body").html(formHTML);

                            //     $.spinner().stop();

                            // }

                            console.log("Client loyalty Check end");

                        });

                    } else {
                        console.log("Client loyalty no questions for this RUT");
                        if (redirect && redirect != "") {
                            console.log("Loyalty client end with error and redirect");
                            location.href = redirect;
                        }
                    }
                } else {
                    console.log("error Service Inscription Questions: " + (data.message ? data.message : ""));
                }
                    
                //$.spinner().stop();
            },
            error: function (err) {
                console.log("Loyalty-Inscription service error:" + err.message);

                $("#loyaltyAssignClub .modal-body").html(err);
                //$.spinner().stop();
            }
        });

    }

    return ({ gerouModal:    modalHtml && modalHtml != "", 
        respostaVazia: respostaVazia});
    
}

var exports = {
    loyaltyModel: loyaltyModel
};

module.exports = exports;

